import React, { ReactNode } from "react";
import { ThemeProvider } from "@mui/material/styles";
// `@mui/system`'s useTheme returns the host theme when an MUI ThemeProvider is
// mounted above us, and a *bare* system default theme otherwise. We can't use
// `@mui/private-theming`'s useTheme here: under MUI 9 the `@mui/material`
// ThemeProvider no longer populates that context, so it always reads `null`
// (treating a present host theme as absent). The bare system default has no
// `palette.primary.main`, so its presence is what tells the two apart.
import { useTheme as useSystemTheme } from "@mui/system";
import { chatDefaultTheme } from "../theme/chatDefaultTheme";

export interface ThemeBridgeProps {
  children: ReactNode;
}

/**
 * If the host has wrapped us in an MUI ThemeProvider, inherit. Otherwise
 * mount chatDefaultTheme.
 */
export function ThemeBridge({ children }: ThemeBridgeProps) {
  const theme = useSystemTheme() as { palette?: { primary?: { main?: string } } };
  // A real host MUI theme carries a palette; the bare system fallback doesn't.
  const hasHostTheme = Boolean(theme?.palette?.primary?.main);
  if (hasHostTheme) return <>{children}</>;
  return <ThemeProvider theme={chatDefaultTheme}>{children}</ThemeProvider>;
}
